import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_VRF_OUTDOOR',
  GET: 'GET_VRF_OUTDOOR',
  CREATE: 'CREATE_VRF_OUTDOOR',
  EDIT: 'EDIT_VRF_OUTDOOR',
  DELETE: 'DELETE_VRF_OUTDOOR',
  DUPLICATE: 'DUPLICATE_VRF_OUTDOOR',
  CLEAR_ERROR: 'CLEAR_ERROR_VRF_OUTDOOR',
};

export const clearErrorVRFOutdoor = () => ({ type: ACTION.CLEAR_ERROR });

const searchVRFOutdoor = (
  pageSize,
  page,
  sorted,
  filtered,
  isPublic,
  excludeZoneId = null,
) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_VRF_OUTDOOR,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => (sort.desc ? `-${sort.id}` : sort.id)).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const searchVRFOutdoorByText = (
  text,
  page = 0,
  excludeZoneId = null,
) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  return searchVRFOutdoor(
    pageSize,
    page,
    withDefaultSort([]),
    text,
    null,
    excludeZoneId,
  );
};

export const listVRFOutdoor = (pageSize, page, sorted, filtered, isPublic) => ({
  type: ACTION.LIST,
  payload: searchVRFOutdoor(pageSize, page, sorted, filtered, isPublic).catch(
    err => Promise.reject(err.response.data),
  ),
});

export const getVRFOutdoor = id => ({
  type: ACTION.GET,
  payload: RestClient.request({
    method: 'get',
    url: `${Constants.API_VRF_OUTDOOR}${id}/`,
  }).catch(err => Promise.reject(err.response.data)),
});

const buildFormData = (
  {
    name,
    brandId,
    coolingCap,
    unitId,
    power,
    seer,
    description,
    image,
    cfp_value: cfpValue,
    cfp_unit: cfpUnit,
  },
  partial,
) => {
  const fd = new FormData();
  const set = (key, val, always) => {
    if (always || val || val === 0) fd.set(key, val);
  };
  set('name', name, !partial);
  if (brandId !== undefined && brandId !== null && brandId !== '')
    fd.set('brand_id', brandId);
  set('cooling_capacity', coolingCap, !partial);
  set('unit', unitId, !partial);
  set('power', power, !partial);
  if (seer !== undefined && seer !== null && seer !== '') fd.set('seer', seer);
  if (typeof description === 'string') fd.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '')
    fd.set('cfp_value', cfpValue);
  if (cfpUnit) fd.set('cfp_unit', cfpUnit);
  if (image) fd.set('image', image, `vrfout_${new Date().valueOf()}`);
  return fd;
};

export const createVRFOutdoor = params => ({
  type: ACTION.CREATE,
  payload: RestClient.request({
    method: 'post',
    url: Constants.API_VRF_OUTDOOR,
    data: buildFormData(params, false),
  }).catch(err => Promise.reject(err.response.data)),
});

export const editVRFOutdoor = (id, params) => ({
  type: ACTION.EDIT,
  payload: RestClient.request({
    method: 'patch',
    url: `${Constants.API_VRF_OUTDOOR}${id}/`,
    data: buildFormData(params, true),
  }).catch(err => Promise.reject(err.response.data)),
});

export const deleteVRFOutdoor = id => ({
  type: ACTION.DELETE,
  payload: RestClient.request({
    method: 'delete',
    url: `${Constants.API_VRF_OUTDOOR}${id}/`,
  })
    .then(() => ({ id }))
    .catch(err => Promise.reject(err.response.data)),
});

export const duplicateVRFOutdoor = (id, name) => ({
  type: ACTION.DUPLICATE,
  payload: RestClient.request({
    method: 'post',
    url: `${Constants.API_VRF_OUTDOOR}${id}/copy/`,
    data: { new_name: name },
  }).catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/vrf/vrf_outdoor_actions.js